<template>
  <!--  <div id="header" class="container" style="width: 1000px"-->
  <div id="header" style="width: 990px;padding: 0 5px 7px"
       v-if="$store.state.user.check_is_wxc_domain() ||  $store.state.user.check_is_wxcblog_domain()">
    <!-- <div id="header" class="container"> -->
    <div id="topnav" class="wxc">
      <n-switch
          class="switchbtn wxc float-left"
          v-model="langswitch"
          on-text="简"
          off-text="繁"
          @input="s_t"
          style="margin:4px 5px"
      ></n-switch>
      <div class="mobilelinks">
        <!--          <span><a class="text-black" href="#">简体版</a></span>-->
        <!--          <span>|</span>-->
        <!--          <span><a  class="text-black" href="#">繁体版</a></span>-->
        <!--          <span>|</span>-->
        <span>
         <a class="app" href="//www.wenxuecity.com/app/" alt="IOS app"></a>
         <a class="andr" href="//www.wenxuecity.com/app/" alt="Android app"></a>
         </span>
      </div>
      <div class="sharelinks">
        <a class="tt" href="https://twitter.com/wenxuecity" alt="Twitter"></a>
        <a class="fb" href="https://www.facebook.com/wenxuecity" alt="Facebook"></a>
      </div>
      <div id="toploginbox" class="quicklinks">
        <!-- 已登录状态 -->
        <div
            v-if="$store.state.user.userinfo.id"
            id="login_in_box">
          <div class="bar_one">
            <!--              帐号管理-->
            <span>[<a
                :href="'https://passport.wenxuecity.com/members/?u='+$store.state.user.userinfo.userinfo_id.username">{{
                $t('message').topnav.wxcprofile
              }}</a>]</span>
            <!--              我的悄悄话-->
            <span>[<a :href="'https://www.wenxuecity.com/qqh/?u='+$store.state.user.userinfo.userinfo_id.username">{{
                $t('message').topnav.myqqh
              }} </a>]</span>
            <!--              我的群吧 /blog/user/-->
            <span>[<router-link :to="'/group/my/'">{{ $t('message').topnav.mygroup }}</router-link>]
          </span>
<!--            <span>[<router-link :to="'/blog/user/'+$store.state.user.userinfo.UserID">   </router-link>]-->
              <!--            我的博客-->
            <span>[<a :href="'https://blog.wenxuecity.com/myblog/'+$store.state.user.userinfo.bbuserinfo.blogid">
                 {{$t('message').topnav.myindex }}
              <!--            </a>]-->
             </a>]</span>
            <span>[<a :href="'//www.wenxuecity.com/bookmark/?u'+$store.state.user.userinfo.userinfo_id.username">
                 我的书签
              <!--            </a>]-->
             </a>]</span>
            <!--            <span>[<a href="#">我的书签</a>]</span>-->

            <span>[
<!--             <a href="javascript:void(0)" @click="logout">-->
           <a :href="'https://passport.wenxuecity.com/members/passport.php?act=logout&amp;='+$store.state.user.userinfo.userinfo_id.username" target="_self">
              {{ $t('message').topnav.logout }}
            </a>]
          </span>
          </div>
          <div class="bar_two">
            <!--              欢迎您-->
            <span> {{ $t('message').topnav.welcome }}：</span>
            <span class="username">
               <a :href="'https://passport.wenxuecity.com/members/?u='+$store.state.user.userinfo.UserID">
               {{ $store.state.user.userinfo.userinfo_id.username }}
             </a>
          </span>
          </div>
        </div>
        <!-- 未登录状态 -->
        <div id="login_out_box">
          <div class="bar_one">
            <form id="login_form" method="post" target="_self"
                  action="https://passport.wenxuecity.com/members/passport.php?act=topbar_post&amp;iframe=0"
                  onsubmit="return validate(this)">
              <input type="hidden" name="redirect" value="https%3A%2F%2Fwww.wenxuecity.com%2F">
              <input type="hidden" name="password" id="password" value="">
              <span class="user"> 用户名：<input class="box" type="text" name="username"> </span>
              <span>密 码：<input class="box" type="password" name="login_password" id="login_password"> </span>
              <span>保持登录<input name="autologin" type="checkbox" id="autologin" value="1"></span>
              <input class="btn" type="submit" name="login" value="登录" onclick="return decode_password();">
              <input class="btn" type="button" value="注册"
                     onclick="self.location='https://passport.wenxuecity.com/members/passport.php?act=register'">
              <span>[<a href="https://passport.wenxuecity.com/members/passport.php?act=forgotpwd">忘记密码</a>]</span>
            </form>
            <!--            <form-->
            <!--                action="https://passport.wenxuecity.com/members/passport.php?act=topbar_post&amp;iframe=0">-->
            <!--&lt;!&ndash;            <el-form :model="wxcForm" :rules="wxcrules" ref="wxcForm" label-width="10px">&ndash;&gt;-->
            <!--              <span class="user"  prop="username"  label="" >用户名：-->
            <!--                <input class="box" type="text" name="username" v-model="wxcForm.username" >-->
            <!--              </span>-->
            <!--              <span  prop="password" label="" >密 码：-->
            <!--                <input class="box" type="password" name="login_password"  v-model="wxcForm.password" autocomplete="off">-->
            <!--              </span>-->
            <!--              <div style="color:#f56c6c;text-align:center" v-if="loginErr.status">{{loginErr.msg}}</div>-->
            <!--              <span>保持登录-->
            <!--                <input name="autologin" type="checkbox" id="autologin" value="1">-->
            <!--              </span>-->
            <!--              <span>-->
            <!--                <input class="btn" type="submit" name="login" value="登录" >-->
            <!--&lt;!&ndash;              <n-button class="btn text-dark"&ndash;&gt;-->
            <!--&lt;!&ndash;                       type="submit" name="login"&ndash;&gt;-->
            <!--&lt;!&ndash;                       @click="submitForm('wxcForm')">登录&ndash;&gt;-->
            <!--&lt;!&ndash;              </n-button>&ndash;&gt;-->
            <!--              </span>-->
            <!--              <input class="btn" type="button" value="注册"-->
            <!--                     onclick="self.location='https://passport.wenxuecity.com/members/passport.php?act=register'">-->
            <!--              <span>[-->
            <!--                  <a href="https://passport.wenxuecity.com/members/passport.php?act=forgotpwd">忘记密码</a>]-->
            <!--                </span>-->
            <!--            </form>-->
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div v-if="$store.state.user.check_is_wxcblog_domain()" class="logo">
        <span class="name">海外博客</span>
      </div>
      <div v-else class="logo">
        <span class="name">海外群吧</span>
      </div>
    </div>
    <div class="menubar" id="mainmenu">
      <ul>
        <div class="menubar wxc">
          <ul>
            <li><a href="//www.wenxuecity.com/">首页</a></li>
            <li><a href="//www.wenxuecity.com/news/">新闻</a></li>
            <li><a href="//www.wenxuecity.com/news/photo/?utm_source=wxc&amp;utm_medium=navi&amp;utm_campaign=05242016">读图</a>
            </li>
            <li><a href="//bbs.wenxuecity.com/financenews/">财经</a></li>
            <li><a href="//www.wenxuecity.com/edu/">教育</a></li>
            <li><a href="//www.wenxuecity.com/home/">家居</a></li>
            <li><a href="//www.wenxuecity.com/health/">健康</a></li>
            <li><a href="//www.wenxuecity.com/cooking/">美食</a></li>
            <li><a href="//www.wenxuecity.com/style/">时尚</a></li>
            <li><a href="//www.wenxuecity.com/travel/">旅游</a></li>
            <li><a href="//www.wenxuecity.com/video/">影视</a></li>
            <div v-if="$store.state.user.check_is_wxcblog_domain()">
              <li class="selected">
                <a href="https://blog.wenxuecity.com/">博客</a>
              </li>
            </div>
            <div v-else>
              <li>
                <a href="https://blog.wenxuecity.com/">博客</a>
              </li>
            </div>
            <div v-if="$store.state.user.check_is_wxc_domain()">
              <li class="selected">
                <a href="https://groups.wenxuecity.com/">群吧</a>
              </li>
            </div>
            <div v-else>
              <li>
                <a href="https://groups.wenxuecity.com/">群吧</a>
              </li>
            </div>
            <li><a href="https://blog.wenxuecity.com/yoyo/?act=list">悠游</a></li>
            <li class="last"><a href="//bbs.wenxuecity.com/">论坛</a></li>
          </ul>
        </div>
      </ul>
    </div>
  </div>
  <div v-else class="sticky-top mb-3">
    <navbar type="white" menu-classes="ml-auto">
      <template>
<!--        <router-link class="navbar-brand" to="/blog">-->
        <router-link class="navbar-brand mr-1" to="/group">
         <img src="/img/logo1.png" alt="海外" height="32">
        </router-link>
        <div class="htop-menu d-flex mt-2">
          <!--       博客链接 start-->
<!--          <router-link-->
<!--              :to="'/blog/'"-->
<!--              class="nav-btn mr-4"-->
<!--              v-bind:class="{active:type==8}"-->
<!--          >-->
<!--            {{ $t('message').blog.index_menu_blog }}-->
<!--          </router-link>-->
<!--       博客链接 end-->
          <router-link
              :to="'/group/'"
              v-bind:class="{active:type==9}"
              class="nav-btn"
          >
            {{ $t('message').group.index_menu_group }}
          </router-link>
          <!--          <n-button-->
          <!--              type="default"-->
          <!--              link-->
          <!--              @click="$router.push('/group')"-->
          <!--              v-bind:class="{active:type==9}"-->
          <!--          >-->
          <!--            <span>{{ $t('message').group.index_menu_group }}</span>-->
          <!--          </n-button>-->
        </div>

        <!-- <el-popover
          ref="popover1"
          popper-class="popover"
          placement="bottom"
          width="200"
          trigger="hover"
        >
          <div class="popover-body">
            This is a tips or slogan
          </div>
        </el-popover> -->
      </template>
      <template slot="before-menu">
      </template>
      <template slot="navbar-menu">
        <div class="searchbar mr-3 small-search">
          <!-- <div style="max-width:500px;padding:0 18px;"> -->
          <!-- <el-autocomplete
            class="inline-input"
            v-model="keyword"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            :trigger-on-focus="false"
            @select="handleSelect"
            @keyup.enter.native="onSubmit"
          ><i slot="prefix" class="el-input__icon el-icon-search"></i>

            <template slot-scope="{ item }">
              <div class="name">{{ item.name }}</div>
            </template>
          </el-autocomplete> -->
          <!-- <fg-input style="margin:0;"
            addon-left-icon="now-ui-icons ui-1_zoom-bold"
            :placeholder="$t('message').topnav.seachplaceholder"
            v-model="keyword"
            @keyup.enter.native="onSubmit"
          >
          </fg-input> -->
          <el-input :placeholder="$t('message').topnav.seachplaceholder" v-model="keyword" class="input-with-select"
                    @keyup.enter.native="onSubmit">
            <el-select v-model="select" slot="prepend" placeholder="请选择">
              <el-option label="文章" value="0"></el-option>
              <el-option label="博客" value="1"></el-option>
              <el-option label="标签" value="2"></el-option>
              <!--            <el-option label="目录" value="3"></el-option>-->
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="onSubmit"></el-button>
          </el-input>
        </div>
        <drop-down v-if="!($route.path.indexOf('/blog/p/'))"
                   class="nav-item dropdown"
                   :haiwaiIcon="icons.font_resize"
                   style="margin-top:3px;"
        >
          <a class="dropdown-item" href="#" @click="setFontSize(0)">小</a>
          <a class="dropdown-item" href="#" @click="setFontSize(1)">中</a>
          <a class="dropdown-item" href="#" @click="setFontSize(2)">大</a>
          <!-- <div class="divider"></div> -->
        </drop-down>
        <n-switch
            class="switchbtn"
            v-model="langswitch"
            on-text="简"
            off-text="繁"
            @input="s_t"
        ></n-switch>
        <li class="nav-item" v-if="$store.state.user.userinfo.id">
          <el-badge :value="$store.state.user.notice.data.totall" :hidden="!$store.state.user.notice.data.totall"
                    :max="99" class="badge-item">
            <router-link
                class="nav-link"
                style="margin-top:3px;z-index:1000"
                rel="tooltip"
                title="消息"
                data-placement="bottom"
                to="/notices?id=0"
            >
              <!-- <div class="noticealert" v-if="$store.state.user.notice.data.totall"></div> -->
              <i v-html="icons.notice" class="notice"></i>
              <p class="d-lg-none d-xl-none">{{ $t('message').topnav.notice }}</p>
            </router-link>
          </el-badge>
        </li>
        <div class="mx-2 loog" style="padding-top:10px" v-if="!$store.state.user.userinfo.id">
          <span style="cursor:pointer" @click="check_user_login()">{{ $t('message').topnav.login }}</span>
        </div>
        <profile-drop-down
            v-if="$store.state.user.userinfo.id"
            tag="li"
            :data="$store.state.user.userinfo.userinfo_id"
            :username="$store.state.user.userinfo.userinfo_id.username"
            :avatarurl="$store.state.user.userinfo.userinfo_id.avatar"
            class="nav-item">
          <nav-link to="/backend" v-if="$store.state.user.userinfo.UserLevel==2">
            <i class="icon" v-html="icons.setting" style="top:-1px"></i> {{ $t('message').topnav.admin }}
          </nav-link>
          <nav-link :to="'/userindex/'+$store.state.user.userinfo.UserID">
            <i class="icon" v-html="icons.user" style="top:-2px"></i> {{ $t('message').topnav.userindex }}
          </nav-link>
<!--          我的博客-->
<!--          <hr class="mb-1 mt-1" v-if="$store.state.user.userinfo.UserLevel==2">-->
<!--          <nav-link :to="'/blog/user/'+$store.state.user.userinfo.UserID">-->
<!--            <i class="el-icon-notebook-2"></i> {{ $t('message').topnav.myindex }}-->
<!--          </nav-link>-->
          <nav-link to="/blog/mygroupblog/" v-if="$store.state.user.groupBlogger">
            <i class="el-icon-document-copy"></i>{{ $t('message').topnav.mygroupblog }}
          </nav-link>
          <hr class="mb-1 mt-1">
          <nav-link to="/group/my/">
            <i class="icon" v-html="icons.mygroupblog" style="top:-2px"></i> {{ $t('message').topnav.mygroup }}
          </nav-link>
          <hr class="mb-1 mt-1">
          <nav-link to="/bookmark">
            <i class="icon" v-html="icons.star_small" style="top:-2px"></i>{{ $t('message').topnav.myfavorite }}
          </nav-link>
          <nav-link to="/notices?id=1">
            <i class="icon" v-html="icons.message"></i> {{ $t('message').topnav.mycomment }}
          </nav-link>
          <nav-link to="/notices?id=2">
            <i class="icon" v-html="icons.mail" style="top:-1px"></i> {{ $t('message').topnav.myqqh }}
          </nav-link>
<!--          海外博客-->
<!--          <nav-link to="/notices?id=3">-->
<!--            <i class="icon" v-html="icons.follower" style="top:-1px"></i> {{ $t('message').topnav.myfuns }}-->
<!--          </nav-link>-->
          <nav-link to="/notices?id=4">
            <i class="icon" v-html="icons.like_outline" style="stroke:#6a6a6a;top:-1px"></i>
            {{ $t('message').topnav.likeme }}
          </nav-link>
          <hr class="mb-2 mt-1">
          <nav-link to="/profile/?id=1">
            <i class="icon" v-html="icons.setting" style="top:-1px"></i> {{ $t('message').topnav.profile }}
          </nav-link>
          <hr class="mb-1 mt-1">
          <a href="javascript:void(0)" @click="logout" class="dropdown-item">
            <i class="icon" v-html="icons.exit" style="top:-1px"></i> {{ $t('message').topnav.logout }}
          </a>
        </profile-drop-down>
        <div class="divider"></div>
        <li v-if="$route.path.includes('/blog')" class="nav-item ml-2 push">
          <n-button v-if="!$store.state.user.groupBlogger"
                    type="primary"
                    simple
                    @click="$router.push('/blog/my/editor/')"
                    class="editbtn">
            <i class="el-icon-edit"></i>
            {{ $t('message').topnav.editbtn }}
          </n-button>
          <el-dropdown
              @command="goGroupBlogEditer"
              trigger="click"
              v-if="$store.state.user.groupBlogger && $store.state.user.userinfo.id">
            <n-button
                type="primary"
                round
                simple
                class="editbtn">
              <icon-pen class="editicon"></icon-pen>
              {{ $t('message').topnav.editbtn }}<i class="ml-2 el-icon-arrow-down"></i>
            </n-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>{{ $t('message').topnav.editbtn_dropdown_0 }}</el-dropdown-item>
              <el-dropdown-item :command="this.$store.state.user.userinfo">我的博客</el-dropdown-item>
              <el-dropdown-item v-for="item in this.$store.state.user.groupBlogger" :key="item.id" :command="item">
                {{ item.bloggerinfo_bloggerID.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </template>
      <template slot="after-menu">
      </template>
    </navbar>
  </div>


</template>

<script>
import icons from "@/components/Icons/Icons";
import {IconPen} from '@/components/Icons';
import {Button, DropDown, FormGroupInput, Navbar, NavLink, ProfileDropDown, Switch} from '@/components';
import {Menu, MenuItem} from 'element-ui';
import blog from '../module/blog/blog.service.js';
import account from '@/module/user/user.service';

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
    type: String,
    index: String,
  },
  components: {
    ProfileDropDown,
    DropDown,
    Navbar,
    NavLink,
    // [Popover.name]: Popover,
    [Switch.name]: Switch,
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    // [Autocomplete.name]: Autocomplete,
    IconPen
  },
  watch: {
    "$store.state.user.groupBlogger": function (val) {
      this.$forceUpdate();
    },
    "$store.state.user.userinfo.id": function (val) {
      this.$forceUpdate();
      if (val) {
        this.notification_unread_count();
        this.unread_count = setInterval(this.notification_unread_count, 10000)
      } else {
        clearInterval(this.unread_count);
      }
    },
    "$route.path": function (val) {
      this.path = val.split('/')[1]
    },
    '$route': function (val) {

    }
  },
  data() {
    var validateMail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱地址'));
      } else {
        account.checkemail(value).then(res => {
          if (res.status) {
            callback(new Error('此邮箱并未在本网站注册'))
          }
          callback();
        })
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    }
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };
    return {
      icons: icons,
      bodyclass: '',
      langswitch: localStorage.lang ? localStorage.lang == 'cns' ? true : false : true,
      keyword: '',
      search: this.$store.state.search,
      stopDOM: ["BR", "TIME", "IMG", "CANVAS", "SCRIPT"],
      currentEncoding: true,
      targetEncoding: true,
      select: '0',
      unread_count: '',
      activeIndex: '/',
      activeIndex2: '/group',
      path: '',
      domain: '',
      wxcForm: {
        username: '',
        password: '',
        submitDisable: false
      },
      wxcrules: {
        username: [
          {required: true, validator: validateName, trigger: 'blur'},
        ],
        password: [
          {required: true, validator: validatePass, trigger: 'blur'},
          // { min: 6, message: '至少 6 个字符', trigger: 'blur' },
        ],
      },
      loginErr: {status: false, msg: ''},
      resetpasswordform: false,
      resetForm: {
        email: '',
        submitDisable: false
      },
      resetrules: {
        email: [
          {required: true, validator: validateMail, trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],
      },
    };
  },
  methods: {
    translatePage() {
      this.currentEncoding = this.targetEncoding;
      this.targetEncoding = !this.targetEncoding;
      localStorage.targetEncoding = this.targetEncoding;
      // this.translateBody();
    },
    async querySearch(queryString, cb) {
      let results = await this.search.getautocomplete(queryString);
      cb(results.data.data);// 调用 callback 返回建议列表的数据
    },

    handleSelect(item) {
      this.keyword = item.name;
      this.doSearch(this.keyword, item.id);
    },
    isGroupBlog() {
      this.$store.state.user.getGroupBlogs().then(res => {
        if (res.status) {
          this.$store.commit('setUserinfoGroupblogs', res.data);
        }
      })
    },
    goGroupBlogEditer(command) {
      if (command.bloggerID != this.$store.state.user.userinfo.bloggerID) {
        this.$router.push('/blog/my/editor/?bloggerID=' + command.bloggerID);
      } else {
        this.$router.push('/blog/my/editor/');
      }
    },
    getBloggerInfo() {
      this.$store.state.user.blogger_profile().then(res => {
        if (res.status) {
          blog.get_blogger_info(res.data.id).then(r => {
            if (r.status) {
              this.$store.state.user.userinfo.bloggerID = res.data.id;
              this.$store.state.user.userinfo.userinfo_bloggerID = r.data;
              this.$store.state.user.userinfo.userID = this.$store.state.user.userinfo.UserID;
            }
          })
        }
      })
    },
    // 簡繁轉換
    s_t(val) {
      if (val) {
        localStorage.lang = 'cns';
      } else {
        localStorage.lang = 'cnt'
      }
      this.$i18n.locale = localStorage.lang
      this.translatePage()
    },
    onSubmit() {
      this.doSearch(this.keyword, this.select);
    },

    async doSearch(k, tab) {
      this.$router.push({path: '/search/', query: {keyword: k, tab: tab}});
    },

    setFontSize(size) {
      let cls = this.bodyclass + ' fontsize' + size;
      document.querySelector('body').setAttribute('class', cls);
    },
    notification_unread_count() {
      this.$store.state.user.notification_unread_count();
    },
    logout() {
      account.logout().then(res => {
        if (res.status == true) {
          this.$store.state.user.userinfo = {};
          this.$store.commit('setUserinfoGroupblogs', false);
          this.$store.commit('setGroupBlogEditer', {});
          this.$store.getters['group/initGroup'];
          this.$forceUpdate();
          location.reload();
        }
      })
    },
    // wxc login
    isShowLogin(v) {
      this.$emit('onchange', v)
    },
    setLoginState(res) {
      this.$store.commit('setUserinfo', res.data);
      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);
      } else if (this.$route.path == "/login") {
        this.$router.push('/');
      } else {
        this.$emit('closedialog')
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === 'loginForm') {
            this.loginForm.submitDisable = true;
            account.login(this.loginForm).then(res => {
              if (res.status) {
                this.setLoginState(res);
              } else {
                this.loginForm.submitDisable = false;
                this.$message.error(res.error);
              }
              this.loginErrFormat(res);
            })
          }
          if (formName === 'wxcForm') {
            this.wxcForm.submitDisable = true;
            account.wxc_sign_in(this.wxcForm).then(res => {
              if (res.status) {
                this.setLoginState(res);
                // this.dialogFormVisible = false;
              } else {
                this.wxcForm.submitDisable = false;
                this.$message.error(res.error);
              }
              this.loginErrFormat(res);
            })
          }
          if (formName === 'resetForm') {
            this.user_password_send_request(this.resetForm.email)
          }
        } else {
          this.loginForm.submitDisable = false;
          this.wxcForm.submitDisable = false;
          return false;
        }
      });
    },
    loginErrFormat(err) {
      if (err.status) {
        this.loginErr.msg = ''
        this.loginErr.status = false;
      } else {
        if (err.error.indexOf('|') != -1) {
          let arr = err.error.split('|');
          this.$emit('onloginerr', arr)
        } else {
          this.loginErr.msg = err.error
          this.loginErr.status = true;
        }
      }
    },
  },
  beforeCreate() {
  },
  created: function () {
    this.bodyclass = document.querySelector('body').classList.value;
    this.getBloggerInfo();
  },


  // check_group(){
  //   if(this.domain!='group1.wenxuecity.com' && domain!='local.haiwai.com:8081 '){
  //     return true;
  //   }else{
  //     return false;
  //   }
  // },

  mounted() {
    this.translatePage();
    this.s_t(this.langswitch);
    this.isGroupBlog();
  },
  destroyed() {
    clearInterval(this.unread_count);
  },
};
</script>

<style>
nav.navbar.bg-white.navbar-expand-lg.navbar-relative {
  padding-bottom: 0;
}
/*多导航默认样式*/
/*.htop-menu a {*/
/*  margin-right: 10px;*/
/*  color: #888888e6 !important;*/
/*  font-size: 22px;*/
/*  line-height: 38px;*/
/*  height: 51px;*/
/*  color: #657786;*/
/*  text-decoration: none;*/
/*}*/
.htop-menu a {
  padding-bottom: 22px;
  color: #5c5c5c!important;
  font-size: 29px;
  line-height: 33px;
  height: 51px;
}
a.nav-btn router-link-active {
  font-weight: 700;
  font-size: 22px;
  line-height: 38px;
  height: 51px;

}
.navbar a:hover {
  text-decoration: none;
}
/*多导航*/
/*a.nav-btn.active.router-link-active.active {*/
/*  padding-bottom: 22px;*/
/*  color: #303133!important;*/
/*  font-size: 22px;*/
/*  line-height: 38px;*/
/*  height: 51px;*/
/*  !*border-bottom: 4px solid #03a9f4;*!*/
/*}*/
a.nav-btn.active.router-link-active.active {
padding-bottom: 22px;
color: #5c5c5c!important;
font-size: 29px;
line-height: 33px;
height: 51px;
}
.htop-menu .active span {
  padding-bottom: 22px;
  color: #303133;
  line-height: 46px;
  border-bottom: 4px solid #03a9f4;
  height: 54px;
}

.searchbar .el-input-group__append {
  background-color: #ffffff !important;
  color: #9e9e9e !important;
}

span.icon {
  margin-right: 5px;
  height: 27px;
}

/*.el-input__inner {*/
/*  border-radius: 20px;*/
/*}*/

.searchbar {
  padding-top: 3px;
}

.searchbar .el-select .el-input {
  width: 80px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-input-group__append {
  border-top-right-radius: 24px !important;
  border-bottom-right-radius: 24px !important;
}

.el-input-group__prepend {
  border-top-left-radius: 24px !important;
  border-bottom-left-radius: 24px !important;
}

.editicon {
  fill: #32caf9;
  margin-right: 4px;
  border-bottom: 1px solid #32caf9;
  height: 20px;
}

.switchbtn {
  margin: 12px 20px;
}

.dropdown-item, .dropdown-item.active, .dropdown-item:active {
  color: #606266 !important;
  background-color: transparent !important;
}

.badge-item .el-badge__content.is-fixed {
  top: 12px;
  right: 20px;
}

.noticealert {
  position: absolute;
  margin-left: 10px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FF3636;
}

.editbtn {
  white-space: nowrap;
}

.nav-item .icon svg {
  width: 18px;
  height: 18px;
}

.notice svg {
  fill: #657786;
}

.htop-menu {
  font-size: 1.2rem !important;
  display: inline-table
}


.htop-menu .active a {
  color: black;
  font-weight: 600;
}

.el-menu--horizontal > .el-menu-item {
  font-size: 20px !important;
}

.htop-menu .el-menu--horizontal > .el-menu-item {
  margin-bottom: -10px;
  padding: 0 0px;
  line-height: 54px;
  margin-right: 22px;
}

.htop-menu .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 4px solid #03a9f4;
  color: #303133;
  font-weight: bold;
}

.htop-menu .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.navbar-translate {
  display: inline-flex !important
}

@media (min-width: 992px) {
  .navbar-expand-lg .container {
    max-width: 1373px !important;
    min-width: 1085px !important;
  }

  #header .menubar {
    height: 137px;
  }

}

@media (max-width: 575.98px) {
  .editbtn {
    color: white !important;
    border-color: white !important;
    margin: 1rem 2rem;
  }

  .editbtn .editicon {
    fill: white;
    border-bottom: 1px solid white;
  }

  .searchbar {
    margin-left: 20px;
    margin-bottom: 20px;
  }

  li.nav-item.ml-2.push {
    margin-left: 30px !important;
  }

  /*.navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn) {*/
  /*  color: #FFFFFF !important;*/
  /*}*/
  .htop-menu a {
    color: #888888e6 !important;
  }
  .switchbtn {
    margin: 12px 30px;
  }

  .mx-2.loog {
    margin: 0 30px 15px !important;
  }

  .sidebar-collapse .navbar-collapse .dropdown-menu .dropdown-item {
    color: #FFFFFD !important;
    background-color: transparent !important;
  }

  html {
    position: relative;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  body {
    top: 0;
    left: 0
  }

  /*#header .menubar {*/
  /*  height: 126px;*/
  /*  !* width: 1000px; *!*/
  /*  background-color: #486c41;*/
  /*}*/
}

@media (max-width: 767.98px) {
  .nav-item .icon svg, .notice svg, g#Shape {
    fill: white;
    stroke: white;
    stroke-width: 0.6px;
  }

  /*#header .menubar {*/
  /*  height: 125px !important;;*/
  /*}*/

  #topnav .quicklinks {
    float: left !important;
  }

  #header #topnav {
    height: 98px !important;
  }

}

/*wxc*/
#header {
  overflow: hidden;
  padding: 0 5px;
  background: #fff;
  margin: 0 auto
}

#header #topnav {
  background: url(https://www.wenxuecity.com/images/bg_topnav.gif) repeat-x;
  border: 1px solid #ccc;
  border-top: 0;
  height: 30px;
  line-height: 30px;
  margin-bottom: 12px;
  font-size: .9em
}

#header .wrapper {
  height: 62px;
  margin-bottom: 10px
}

#header .menubar {
  height: 37px
}

.menubar ul {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-left: 5px
}

.menubar ul a {
  text-decoration: none;
  color: #fff
}

.menubar ul li.selected a {
  color: #000
}

#topnav {
  overflow: hidden
}

#topnav .mobilelinks {
  float: left;
  width: 190px;
  _width: 200px;
  padding-left: 10px;
  padding-bottom: 5px
}

#topnav .mobilelinks span {
  display: block;
  float: left;
  padding-right: 4px;
  *padding-top: 1px;
  _padding-top: 2px;
  line-height: 28px
}

#topnav .sharelinks {
  float: left;
  width: 50px;
  padding-bottom: 5px
}

#topnav .sharelinks a {
  display: block;
  line-height: 28px
}

#topnav .mobilelinks img, #topnav .sharelinks img {
  float: left;
  padding-top: 7px;
  border: 0
}

#topnav img {
  margin: 0 4px
}

#topnav .quicklinks {
  float: right
}

#topnav .quicklinks span {
  float: left;
  margin-left: 5px;
  display: block;
  *padding-top: 0;
  _padding-top: 4px
}

#topnav .quicklinks .bar_two span {
  margin-left: 0
}

#topnav .quicklinks span.login {
  background: url(https://www.wenxuecity.com/images/dividingline.gif) no-repeat center right
}

.bar_one span a {
  color: #333;
  text-decoration: none
}

.bar_one span a:hover {
  color: red;
  text-decoration: underline
}

.bar_one span.user {
  margin-right: 5px;
  *padding-bottom: 4px
}

.bar_two span.username {
  margin-right: 5px;
  _margin-right: 0
}

.bar_two span.username a {
  color: red
}

.bar_one input.box {
  width: 80px;
  height: 18px;
  line-height: 18px;
  border: 1px solid #ddd
}

.bar_one .btn {
  border: 0;
  float: left;
  font-size: 12px;
  background: url(https://www.wenxuecity.com/images/btn_login.gif) no-repeat;
  width: 55px;
  height: 22px;
  line-height: 22px;
  margin-left: 8px;
  margin-top: 4px;
  color: #333 !important;
  padding: 0
}

.bar_one input.text {
  width: 80px;
  font-size: 12px;
  margin-left: 5px
}

.bar_one input.password {
  width: 80px;
  height: 14px;
  font-size: 13px
}

#login_in_box, #login_out_box {
  font-size: 13px;
  background: url(https://www.wenxuecity.com/images/bg_topnav.gif);
  font-family: "Microsoft YaHei", Tahoma, Verdana, STHeiTi, simsun, sans-serif;
  padding: 0 3px;
  border: 0
}

#login_in_box {
  height: 30px;
  line-height: 30px
}

#login_out_box .bar_one {
  padding: 0 10px;
  _padding: 0;
  float: right
}

#login_in_box .bar_one {
  padding: 0;
  float: right;
  vertical-align: middle
}

#login_in_box .bar_two {
  padding: 0 10px;
  padding-right: 0;
  float: right
}

#login_in_box .bar_one span {
  display: block;
  float: left;
  vertical-align: middle;
  _padding-bottom: 4px
}

#header .wrapper .logo {
  float: left;
  width: 251px;
  height: 58px;
  background: url("https://www.wenxuecity.com/images/logo_wxc_wide.gif") no-repeat scroll 0 0 rgba(0, 0, 0, 0);
  margin-right: 28px
}

#header .wrapper .logo span.name {
  float: right;
  width: 43px;
  font-size: 1.2em;
  line-height: 20px;
  padding-top: 5px;
  display: block
}

#header .wrapper .logo img {
  width: 193px;
  height: 62px
}

#header .wrapper .searchbox {
  float: right;
  width: 224px;
  height: 24px;
  border: 1px solid #ccc;
  padding-top: 6px;
  padding-left: 10px;
  margin: 25px 10px 0 0;
  color: #ccc
}

#header .wrapper .button {
  float: right;
  width: 84px;
  padding-top: 25px
}

#header .wrapper .button img {
  width: 84px;
  height: 32px
}

#keyword {
  border: 1px solid #CCC;
  color: #666;
  height: 29px;
  line-height: 29px;
  width: 224px;
  padding-left: 10px
}

#searchBbs input {
  float: left;
  margin: 25px 0 0 10px
}

#searchBbs {
  float: right
}

#mainmenu {
  background: url(https://www.wenxuecity.com/images/bg_menubar.jpg) repeat-x
}

#mainmenu ul li.selected {
  background: url(https://www.wenxuecity.com/images/bg_mainmenu_selected.gif) no-repeat center bottom;
  line-height: 25px;
  padding: 7px 11px 7px 15px;
}

#mainmenu ul li.last {
  background: 0 0
}

#submenu {
  clear: both;
  background: #fff;
  border-bottom: 1px solid #cbcbcb;
  vertical-align: middle
}

#submenu a {
  color: #7b686a
}

#submenu ul li {
  background: url(https://www.wenxuecity.com/images/bg_submenuline.gif) no-repeat right bottom;
  font-size: .85em;
  font-family: Arial, Helvetica, sans-serif;
  padding-top: 10px
}

#submenu ul li.newgroup {
  background: 0 0
}

#submenu ul li.newgroup a {
  color: red
}

#submenu ul li.selected a {
  color: #7B686A
}

#submenu ul li a:hover {
  text-decoration: underline
}

.mobilelinks {
  width: 232px
}

.lod {
  float: right;
  margin-right: 30px
}

.app, .andr, .tt, .fb {
  background: url("https://www.wenxuecity.com/images/bbg.png") no-repeat
}

.app, .andr, .tt, .fb {
  width: 22px;
  height: 16px;
  display: block;
  float: left;
  margin: 7px 0 0 0
}

.app {
  background-position: 0 0
}

.andr {
  background-position: -24px 0
}

.tt {
  background-position: 0 -24px
}

.fb {
  background-position: -24px -24px
}

.bar_two span.username a {
  color: #ff0000
}

div#submenu {
  height: 30px !important
}

.banner {
  padding: 30px 0;
  margin: 0 auto;
  text-align: center
}

#submenu ul {
  margin: 0
}

#submenu ul li {
  background: 0;
  padding-top: 5px
}
.menubar.wxc ul li {
  font-size: 15px;
}
.menubar ul li {
  float: left;
  font-size: 18px;
  padding: 6px 11px 10px 15px;
  text-align: center
}

.my-3 {
  margin: 30px 0
}

.mb, .sidebar .banners img, .sidebar .block {
  margin-bottom: 30px
}

#topnav .mobilelinks .switchbtn span {
  line-height: 18px;
}
</style>
